module.exports = __webpack_public_path__ + "img/new-global.a435b78f.gif";